export default function ArrowFilledSVG({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill="#FFFFFF"
      height={12}
      width={12}
      viewBox="0 0 51.19 27.5"
    >
      <polygon points="0 0 51.19 0 25.59 27.5 0 0" />
    </svg>
  );
}
